// Brazilian national format:
//   fixo  (10 digits): (XX) XXXX-XXXX
//   móvel (11 digits): (XX) XXXXX-XXXX
export function formatPhone(value) {
  const d = String(value || "").replace(/\D/g, "");
  if (d.length === 11) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  }
  if (d.length === 10) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  }
  return value || "";
}
